import { useState } from "react";
import { DropdownMenu, Icon, Typography } from "@/components/atoms";
import { FavouritePassenger } from "@/redux/apis/favouritePassenger/types";
import { AddEditGuestModal } from "./AddEditGuestModal";
import { RemoveGuestModal } from "./RemoveGuestModal";

interface GuestPassengerRowMenuProps {
  guest: FavouritePassenger;
  accountId?: string;
}

export const GuestPassengerRowMenu = ({ guest, accountId }: GuestPassengerRowMenuProps) => {
  const [activeModal, setActiveModal] = useState<"edit" | "remove" | null>(null);

  return (
    <>
      <DropdownMenu
        button={
          <DropdownMenu.Button aria-label="Guest actions" className="inline-flex items-center justify-center text-neutral-black">
            <Icon name="options" isCustom size="lg" />
          </DropdownMenu.Button>
        }
        isCustomButton
        position="bottom-end"
      >
        <DropdownMenu.Item onClick={() => setActiveModal("edit")} className="w-56">
          <Icon name="Edit2" size="sm" className="mr-2.5 flex-shrink-0 text-primary-dark" />
          <Typography className="text-primary-dark">Edit</Typography>
        </DropdownMenu.Item>
        <DropdownMenu.Item onClick={() => setActiveModal("remove")} className="w-56">
          <Icon name="Trash" size="sm" className="mr-2.5 flex-shrink-0 text-danger" />
          <Typography className="text-danger">Remove</Typography>
        </DropdownMenu.Item>
      </DropdownMenu>

      <AddEditGuestModal
        open={activeModal === "edit"}
        mode="edit"
        guest={guest}
        accountId={accountId}
        onClose={() => setActiveModal(null)}
      />
      <RemoveGuestModal open={activeModal === "remove"} guest={guest} accountId={accountId} onClose={() => setActiveModal(null)} />
    </>
  );
};
